import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import { FRIEND_INVITATION_CODES, resolveSignupCampaignCode } from '../domain';
dayjs.extend(isToday);
// 過去に使っていて、命名が被るとバグが出るのでコメントアウトで残しています
export const LocalStorageType = {
    Stats: 'stats', // Deprecated: 初期はLocalStorageを1つのkeyで管理してました
    AuthTokenKey: 'authToken',
    HideAppstore: 'hideAppstore',
    LoginStateKey: 'loggedIn',
    // ReleaseNotificationIds: 'releaseNotificationIds',
    // HalloweenLiveEventDialog2021: 'halloweenLiveEventDialog2021',
    HomeDialogId: 'homeDialogId',
    // HoldingLiveLessonId: 'holdingLiveLessonId',
    // SmartHabitDialog: 'smartHabitDialog',
    NavigationTabs: 'navigationTabs',
    UserSeasonAggregateRank: 'userSeasonAggregateRank',
    LoggedInPlatform: 'loggedInPlatform',
    BqSnsShareClickParams: 'BqSnsShareClickParams',
    TwitterRedirectData: 'TwitterRedirectData',
    SearchHistories: 'SearchHistories',
    // CourseInstructorCode: 'courseInstructorCode',
    CourseCode: 'courseCode',
    DeletedAtCancelUnsubscribeBanner: 'deletedAtCancelUnsubscribeBanner',
    CampaginCode: 'campaignCode',
    IsBulkRegistration: 'isBulkRegistration',
    AndroidNotificationPermissionRequestUiDismissals: 'android_notification_permission_request_ui_dismissals',
    TvConnectionBannerDismissedAt: 'tvConnectionBannerDismissedAt',
    GoalMatchingAssessmentParams: 'goalMatchingAssessmentParams',
    CompletedSignupAssessmentFlow: 'completedSignupAssessmentFlow',
    DiagnosisParams: 'diagnosisParams',
    StreakFreezeUsedYesterdayModalDisplayedAt: 'streakFreezeUsedYesterdayModalDisplayedAt',
    BeginnerMissionHomeVisitDate: 'beginnerMissionHomeVisitDate',
    BeginnerMissionAchievedCount: 'beginnerMissionAchievedCount',
    HasRecordedMealV2: 'hasRecordedMealV2',
};
export const SEARCH_HISTORIES_MAX_NUM = 10; // 検索履歴の最大保存数
export const CAMPAIGN_CODE_RESET = 'reset'; // LPからの遷移で、無料期間のプランを確実に反映できるように、localstorageにあるキャンペーンコードを削除する
const CAMPAIGN_CODE_RESET_2024_05_15 = 'reset_2024_05_15'; // 2024年5月15日価格改定対応のためのコード。CAMPAIGN_CODE_RESETと同様
export const SignInType = {
    email: 'email',
};
export const LoggedInPlatForm = {
    facebook: 'facebook',
    apple: 'apple',
    line: 'line',
};
export class LocalStorage {
    constructor() {
        Object.defineProperty(this, "storage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: localStorage
        });
    }
    /*-----------------------------------*/
    loadObjByKey(key) {
        const stats = this.storage.getItem(key);
        return JSON.parse(stats);
    }
    removeKey(key) {
        this.storage.removeItem(key);
    }
    saveLoginState(loggedIn) {
        this.storage.setItem(LocalStorageType.LoginStateKey, JSON.stringify(loggedIn));
    }
    loadLoginState() {
        return this.loadObjByKey(LocalStorageType.LoginStateKey);
    }
    destroy() {
        this.storage.removeItem(LocalStorageType.Stats);
    }
    saveStats(stats) {
        const saveData = Object.assign({}, this.loadStats(), Object.assign({}, stats));
        if (saveData) {
            this.storage.setItem(LocalStorageType.Stats, JSON.stringify(saveData));
        }
    }
    loadStats() {
        return this.loadObjByKey(LocalStorageType.Stats);
    }
    saveSignInType(type) {
        return this.saveStats({ signInType: type });
    }
    get loadSignInType() {
        var _a;
        return (_a = this.loadStats()) === null || _a === void 0 ? void 0 : _a.signInType;
    }
    saveHideAppstore(hideAppstore) {
        this.saveStats({ hideAppstore: hideAppstore });
    }
    get loadHideAppstore() {
        var _a;
        return ((_a = this.loadStats()) === null || _a === void 0 ? void 0 : _a.hideAppstore) || false;
    }
    saveHideFavoriteMessageDialog(hide) {
        this.saveStats({ hideFavoriteMessageDialog: hide });
    }
    get loadHideFavoriteMessageDialog() {
        var _a;
        return ((_a = this.loadStats()) === null || _a === void 0 ? void 0 : _a.hideFavoriteMessageDialog) || false;
    }
    saveShowMealTaskNotificationPermissionDialog(show) {
        this.saveStats({ showMealTaskNotificationPermissionDialog: show });
    }
    get loadShowMealTaskNotificationPermissionDialog() {
        var _a;
        return ((_a = this.loadStats()) === null || _a === void 0 ? void 0 : _a.showMealTaskNotificationPermissionDialog) || false;
    }
    saveHasRecordedMeal(value) {
        this.saveStats({ hasRecordedMeal: value });
    }
    get loadHasRecordedMeal() {
        var _a;
        return ((_a = this.loadStats()) === null || _a === void 0 ? void 0 : _a.hasRecordedMeal) || false;
    }
    saveHasRecordedMealV2(value) {
        this.storage.setItem(LocalStorageType.HasRecordedMealV2, JSON.stringify(value));
    }
    get loadHasRecordedMealV2() {
        return this.loadObjByKey(LocalStorageType.HasRecordedMealV2) || false;
    }
    saveInvitationCode(code) {
        // SNSログイン等でリダイレクトされた後にinvitationCodeが空に上書きされないようにcodeがある時だけ保存している
        // 「invitationCodeを保存しつつ、2週間無料プランで登録」という挙動をさせないために、loadInvitationCode()でハンドリングしています
        if (code) {
            this.saveStats({ invitationCode: code });
        }
    }
    removeInvitationCode() {
        this.saveStats({ invitationCode: null });
    }
    // お友だち紹介コード
    get loadInvitationCode() {
        var _a;
        // 友達招待のキャンペーンコードがある時のみ、invitationCodeをリクエストに含めることができる
        const isFriendInvitationCampaign = FRIEND_INVITATION_CODES.includes(this.loadCampaingCode);
        return isFriendInvitationCampaign ? (_a = this.loadStats()) === null || _a === void 0 ? void 0 : _a.invitationCode : null;
    }
    saveCampaingCode(campaignCode) {
        if (campaignCode === CAMPAIGN_CODE_RESET || campaignCode === CAMPAIGN_CODE_RESET_2024_05_15) {
            this.storage.removeItem(LocalStorageType.CampaginCode);
            this.saveStats({ LP: null }); // 旧仕様で保存してるパラメータも削除
        }
        else if (campaignCode) {
            this.storage.setItem(LocalStorageType.CampaginCode, JSON.stringify(resolveSignupCampaignCode(campaignCode)));
        }
    }
    get loadCampaingCode() {
        var _a, _b;
        // 旧仕様で保存してるパラメータを保存してる可能性がある
        const oldCampaignCode = ((_b = (_a = this.loadStats()) === null || _a === void 0 ? void 0 : _a.LP) === null || _b === void 0 ? void 0 : _b.campaignCode) || '';
        if (oldCampaignCode !== '') {
            return resolveSignupCampaignCode(oldCampaignCode);
        }
        return resolveSignupCampaignCode(this.loadObjByKey(LocalStorageType.CampaginCode) || '');
    }
    removeCampaignCode() {
        this.storage.removeItem(LocalStorageType.CampaginCode);
    }
    // メガロスクーポンコードを利用しようとしているか
    get lpParamsHasMegalosCampaignCode() {
        return this.loadCampaingCode === 'megalos_leanbody';
    }
    // moppy(ポイ活)経由のキャンペーンコードか。ad-trackのCVタグはこの場合のみ発火させる
    get lpParamsHasMoppyCampaignCode() {
        return this.loadCampaingCode === 'ceres';
    }
    saveReferrer(referrer) {
        this.saveStats({ referrer: referrer });
    }
    get loadStatsReferrer() {
        var _a;
        return ((_a = this.loadStats()) === null || _a === void 0 ? void 0 : _a.referrer) || null;
    }
    saveLpMessageReferrer(referrer) {
        this.saveStats({ lpMessage: { referrer } });
    }
    get loadLpMessageReferrer() {
        var _a, _b;
        return ((_b = (_a = this.loadStats()) === null || _a === void 0 ? void 0 : _a.lpMessage) === null || _b === void 0 ? void 0 : _b.referrer) || null;
    }
    // RELOCLUBユーザーIDの取得
    saveReloclubKid(kid) {
        this.saveStats({ reloclubKid: kid });
    }
    // RELOCLUBユーザーIDの取得
    get loadReloclubKid() {
        var _a;
        return ((_a = this.loadStats()) === null || _a === void 0 ? void 0 : _a.reloclubKid) || null;
    }
    saveNtaId(id) {
        this.saveStats({ ntaId: id });
    }
    get loadNtaId() {
        var _a;
        return ((_a = this.loadStats()) === null || _a === void 0 ? void 0 : _a.ntaId) || null;
    }
    saveHomeDialogId(id) {
        this.storage.setItem(LocalStorageType.HomeDialogId, JSON.stringify(id));
    }
    get loadHomeDialogId() {
        return this.loadObjByKey(LocalStorageType.HomeDialogId) || 0;
    }
    saveBeginnerMissionHomeVisitDate(date) {
        this.storage.setItem(LocalStorageType.BeginnerMissionHomeVisitDate, date);
    }
    loadBeginnerMissionHomeVisitDate() {
        return this.storage.getItem(LocalStorageType.BeginnerMissionHomeVisitDate);
    }
    saveBeginnerMissionAchievedCount(count) {
        this.storage.setItem(LocalStorageType.BeginnerMissionAchievedCount, JSON.stringify(count));
    }
    loadBeginnerMissionAchievedCount() {
        const count = this.storage.getItem(LocalStorageType.BeginnerMissionAchievedCount);
        return count === null ? null : JSON.parse(count);
    }
    removeBeginnerMissionAchievedCount() {
        this.storage.removeItem(LocalStorageType.BeginnerMissionAchievedCount);
    }
    saveCourseCode(code) {
        this.storage.setItem(LocalStorageType.CourseCode, JSON.stringify(code));
    }
    saveLiveScheduleTabNoticed() {
        const navigationTab = Object.assign(this.loadNavigationTabNotice, {
            liveSchedule: new Date(),
        });
        this.storage.setItem(LocalStorageType.NavigationTabs, JSON.stringify(navigationTab));
    }
    get loadNavigationTabNotice() {
        return this.loadObjByKey(LocalStorageType.NavigationTabs) || {};
    }
    get noticedLiveScheduleTabToday() {
        if (!this.loadNavigationTabNotice.liveSchedule)
            return false;
        return dayjs(this.loadNavigationTabNotice.liveSchedule).isToday();
    }
    saveUserSeasonAggregateRank(v) {
        this.storage.setItem(LocalStorageType.UserSeasonAggregateRank, JSON.stringify(v));
    }
    get loadUserSeasonAggregateRank() {
        return this.loadObjByKey(LocalStorageType.UserSeasonAggregateRank);
    }
    saveLoggedInPlatform(v) {
        this.storage.setItem(LocalStorageType.LoggedInPlatform, JSON.stringify(v));
    }
    get loadLoggedInPlatform() {
        return this.loadObjByKey(LocalStorageType.LoggedInPlatform);
    }
    resetLoggedInPlatform() {
        this.storage.removeItem(LocalStorageType.LoggedInPlatform);
    }
    saveBqSnsShareClickParams(v) {
        this.storage.setItem(LocalStorageType.BqSnsShareClickParams, JSON.stringify(v));
    }
    get loadBqSnsShareClickParams() {
        return this.loadObjByKey(LocalStorageType.BqSnsShareClickParams);
    }
    saveTwitterRedirectData(v) {
        this.storage.setItem(LocalStorageType.TwitterRedirectData, JSON.stringify(v));
    }
    get loadTwitterRedirectData() {
        return this.loadObjByKey(LocalStorageType.TwitterRedirectData);
    }
    resetTwitterData() {
        this.storage.removeItem(LocalStorageType.BqSnsShareClickParams);
        this.storage.removeItem(LocalStorageType.TwitterRedirectData);
    }
    saveSearchHistories(v) {
        this.storage.setItem(LocalStorageType.SearchHistories, JSON.stringify(v));
    }
    get loadSearchHistories() {
        return this.loadObjByKey(LocalStorageType.SearchHistories);
    }
    saveIsBulkRegistration(v) {
        this.storage.setItem(LocalStorageType.IsBulkRegistration, JSON.stringify(v));
    }
    get loadIsBulkRegistration() {
        return this.loadObjByKey(LocalStorageType.IsBulkRegistration);
    }
    removeAfterCCRegistration() {
        // 友だち紹介コードは再利用できないように削除
        this.removeInvitationCode();
        // クレカ登録以降はデータ永続化させたくないので、RELOCLUBのユーザIDをリセット
        this.saveReloclubKid(null);
        // campaignCodeはクレカ登録後、次回使えなくしたいので削除する
        this.storage.removeItem(LocalStorageType.CampaginCode);
        // NTA成果報告は登録完了時に一度だけ発火させたいので、二重送信防止のためntaIdを削除
        this.saveNtaId(null);
    }
    loadAndroidNotificationPermissionRequestUIDismissals() {
        const setting = this.storage.getItem(LocalStorageType.AndroidNotificationPermissionRequestUiDismissals);
        if (setting) {
            return JSON.parse(setting);
        }
        return {
            liveLessonBanner: false,
            mealTaskDialog: false,
        };
    }
    setAndroidNotificationPermissionRequestUIDismissals(params) {
        this.storage.setItem(LocalStorageType.AndroidNotificationPermissionRequestUiDismissals, JSON.stringify(params));
    }
    get loadDeletedAtCancelUnsubscribeBanner() {
        return this.loadObjByKey(LocalStorageType.DeletedAtCancelUnsubscribeBanner) || 0;
    }
    setDeletedAtCancelUnsubscribeBanner(unixdate) {
        this.storage.setItem(LocalStorageType.DeletedAtCancelUnsubscribeBanner, JSON.stringify(unixdate));
    }
    get loadTvConnectionBannerDismissedAt() {
        return this.loadObjByKey(LocalStorageType.TvConnectionBannerDismissedAt) || 0;
    }
    setTvConnectionBannerDismissedAt(unixdate) {
        this.storage.setItem(LocalStorageType.TvConnectionBannerDismissedAt, JSON.stringify(unixdate));
    }
    saveStreakFreezeUsedYesterdayModalDisplayedAt(unixdate) {
        this.storage.setItem(LocalStorageType.StreakFreezeUsedYesterdayModalDisplayedAt, JSON.stringify(unixdate));
    }
    get loadStreakFreezeUsedYesterdayModalDisplayedAt() {
        return this.loadObjByKey(LocalStorageType.StreakFreezeUsedYesterdayModalDisplayedAt) || 0;
    }
    get noticedStreakFreezeUsedYesterdayModalToday() {
        if (!this.loadStreakFreezeUsedYesterdayModalDisplayedAt)
            return false;
        return dayjs(this.loadStreakFreezeUsedYesterdayModalDisplayedAt * 1000).isToday();
    }
    saveGoalMatchingAssessmentParams(v) {
        this.storage.setItem(LocalStorageType.GoalMatchingAssessmentParams, JSON.stringify(v));
    }
    loadGoalMatchingAssessmentParams() {
        return this.loadObjByKey(LocalStorageType.GoalMatchingAssessmentParams);
    }
    removeGoalMatchingAssessmentParams() {
        this.storage.removeItem(LocalStorageType.GoalMatchingAssessmentParams);
    }
    saveMatchingAssessmentDiagnosisParams(v) {
        this.storage.setItem(LocalStorageType.DiagnosisParams, JSON.stringify(v));
    }
    loadMatchingAssessmentDiagnosisParams() {
        return this.loadObjByKey(LocalStorageType.DiagnosisParams);
    }
    removeMatchingAssessmentDiagnosisParams() {
        this.storage.removeItem(LocalStorageType.DiagnosisParams);
    }
    saveCompletedSignupAssessmentFlow(v) {
        this.storage.setItem(LocalStorageType.CompletedSignupAssessmentFlow, JSON.stringify(v));
    }
    get loadCompletedSignupAssessmentFlow() {
        return this.loadObjByKey(LocalStorageType.CompletedSignupAssessmentFlow);
    }
    removeCompletedSignupAssessmentFlow() {
        this.storage.removeItem(LocalStorageType.CompletedSignupAssessmentFlow);
    }
}
